import { useEffect, useRef } from 'react';
import { useGTM } from './useGTM';

export const useScrollTracking = (pageName: string) => {
  const { pushEvent } = useGTM();
  const trackedMilestones = useRef<Set<number>>(new Set());

  useEffect(() => {
    const handleScroll = () => {
      const scrollPercent = Math.round(
        (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100
      );

      const milestones = [25, 50, 75, 90, 100];
      milestones.forEach((milestone) => {
        if (scrollPercent >= milestone && !trackedMilestones.current.has(milestone)) {
          trackedMilestones.current.add(milestone);
          pushEvent('scroll_depth', {
            page: pageName,
            depth: milestone,
          });
        }
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [pageName, pushEvent]);
};
